import Vue from 'vue';
import iView from 'iview';
import VueRouter from 'vue-router';
import Vuex from 'vuex';



// WEBPACK FOOTER //
// src/vendors/vendors.base.js